"use strict";
// packages/rdti-schema/src/types.ts
//
// Year-versioned AusIndustry R&D Tax Incentive registration schema.
//
// Each financial year (FY24, FY25, ...) declares the project / core activity /
// supporting activity field definitions that AusIndustry expects on the
// registration form for that year. Project rows store a `schemaVersion`
// pointer plus a `responses` JSON blob keyed by FieldDef.key, and the UI,
// exports, AI enhancer, and compliance scorer all render against the
// matching schema definition.
Object.defineProperty(exports, "__esModule", { value: true });
